
import 'react-phone-input-2/lib/style.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validEmpty, validPassword, validPhone } from '../utilities/valid';
import { loadCountries, loadPatientResultPref, loadUrgentResultPref, loadAccount } from '../utilities/httpRequest';
import React from 'react';
import Cookies from 'js-cookie';
import InputText from "../components/InputText";
import TextButton from "../components/TextButton";
import InputSelect from '../components/InputSelect';
import InputPhone from '../components/InputPhone';
import InputCheckBox from '../components/InputCheckBox';
import classNames from 'classnames';

export default function ContentCoordinateForm() {

    const [dataTab1, setDataTab1] = useState({
        email: {
            value: "",
            valid: ""
        },
        password: {
            value: "",
            valid: ""
        }
    });
    const [dataTab2, setDataTab2] = useState({
        name: {
            value: "",
            valid: ""
        },
        firstname: {
            value: "",
            valid: ""
        },
        phone: {
            value: "",
            valid: ""
        },
        street: {
            value: "",
            valid: ""
        },
        streetNb: {
            value: "",
            valid: ""
        },
        postalCode: {
            value: "",
            valid: ""
        },
        country: {
            value: "",
            valid: ""
        },
        language: {
            value: "",
            valid: ""
        },
        box: {
            value: "",
            valid: ""
        }
    });
    const [dataTab3, setDataTab3] = useState({
        patient_result_preference: {
            value: "",
            valid: ""
        },
        urgent_result_preference: {
            value: [],
            valid: ""
        },
        newsletter: {
            value: "",
            valid: ""
        }
    });

    const fillData = (account) => {

        setDataTab1({
            email: {
                value: account.individual.email,
                valid: ""
            },
            password: {
                value: "",
                valid: ""
            }
        });
        setDataTab2({
            name: {
                value: account.individual.last_name,
                valid: ""
            },
            firstname: {
                value: account.individual.first_name,
                valid: ""
            },
            phone: {
                value: account.individual.phone !== null ? account.individual.phone : "",
                valid: ""
            },
            street: {
                value: account.individual.address !== null ? account.individual.address.street : "",
                valid: ""
            },
            streetNb: {
                value: account.individual.address !== null ? account.individual.address.number : "",
                valid: ""
            },
            postalCode: {
                value: account.individual.address !== null ? account.individual.address.postal_code : "",
                valid: ""
            },
            country: {
                value: account.individual.address !== null ? account.individual.address.country : "",
                valid: ""
            },
            language: {
                value: account.individual.language,
                valid: ""
            },
            box: {
                value: account.individual.address !== null ? account.individual.address.box : "",
                valid: ""
            }
        });
        setDataTab3({
            patient_result_preference: {
                value: account.patient_result_preference,
                valid: ""
            },
            urgent_result_preference: {
                value: account.urgency_preferences,
                valid: ""
            },
            newsletter: {
                value: account.newsletter,
                valid: ""
            }
        });
    }

    const navigate = useNavigate();

    useEffect(() => { loadAccount(undefined, navigate, fillData) }, [navigate]);

    const [countries, setCountries] = useState([]);

    useEffect(() => { loadCountries(setCountries, navigate) }, [navigate]);

    const [patientResultPref, setPatientResultPref] = useState([]);
    useEffect(() => { loadPatientResultPref(setPatientResultPref, navigate) }, [navigate]);

    const [urgentResultPref, setUrgentResultPref] = useState([]);
    useEffect(() => { loadUrgentResultPref(setUrgentResultPref, navigate) }, [navigate]);

    const [reducedTab1, setReducedTab1] = useState(true);
    const [reducedTab2, setReducedTab2] = useState(true);
    const [reducedTab3, setReducedTab3] = useState(true);

    return (
            <div className="p-3 flex flex-col gap-3 flex-wrap items-start max-h-full w-72">
                <div className="box-container p-3 w-72 pb-5">
                    <div className="flex flex-row justify-between cursor-pointer" onClick={() => setReducedTab1(!reducedTab1)}>
                        <h2 className="text-base" >Identifiants</h2>
                        <img
                            alt="reduce"
                            className={classNames("size-6",(reducedTab1 ? "" : "rotate-180"))}
                            src="/iconslimsvet/expand.svg"
                            onClick={() => setReducedTab1(!reducedTab1)}
                        />
                    </div>
                    {!reducedTab1 && <Tab1 data={dataTab1} setData={setDataTab1} />}
                </div>
                <div className="box-container p-3 w-72 pb-5">
                    <div className="flex flex-row justify-between cursor-pointer" onClick={() => setReducedTab2(!reducedTab2)}>
                        <h2 className="text-base">Informations personnelles</h2>
                        <img
                            alt="reduce"
                            className={classNames("size-6",(reducedTab2 ? "" : "rotate-180"))}
                            src="/iconslimsvet/expand.svg"
                            onClick={() => setReducedTab2(!reducedTab2)}
                        />
                    </div>
                    {!reducedTab2 && <Tab2 data={dataTab2} setData={setDataTab2} countries={countries} />}
                </div>
                <div className="box-container p-3 w-72 pb-5">
                    <div className="flex flex-row justify-between cursor-pointer" onClick={() => setReducedTab3(!reducedTab3)}>
                        <h2 className="text-base">Préférences</h2>
                        <img
                            alt="reduce"
                            className={classNames("size-6",(reducedTab3 ? "" : "rotate-180"))}
                            src="/iconslimsvet/expand.svg"
                            onClick={() => setReducedTab3(!reducedTab3)}
                        />
                    </div>
                    {!reducedTab3 && <Tab3 data={dataTab3} setData={setDataTab3} patientResultPref={patientResultPref} urgentResultPref={urgentResultPref} />}
                </div>
            </div>

    );
}
const Tab1 = (({ data, setData }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: {
                value: value,
                valid: ""
            }
        }));
    }

    const submit = () => {

        const validateField = () => {
            let validation = true;
            let dataTmp = { ...data };
            //Champs requis
            if (!validEmpty(data.password.value)) {
                dataTmp.password.valid = "Requis";
                validation = false;
            } else if (!validPassword(data.password.value)) {
                dataTmp.password.valid = "Non valide";
                validation = false;
            }
            setData(dataTmp);
            return validation;
        }

        const formatData = () => {

            const formattedData = {
                password: data.password.value === "" ? null : data.password.value
            }
            return formattedData;
        }

        const pushData = () => {

            const xhttp = new XMLHttpRequest();
            document.getElementById("loading").style.display = "flex";
            xhttp.onload = function () {
                if (xhttp.status >= 200 && xhttp.status < 300) {
                    document.getElementById("loading").style.display = "none";
                    window.alert("Données modifiées");
                } else {
                    document.getElementById("loading").style.display = "none";
                    window.alert(this.responseText);
                }
            }
            xhttp.open("PUT", process.env.REACT_APP_API_URL + "account", process.env.REACT_APP_API_HTTPS);
            xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
            xhttp.send(JSON.stringify(formatData()));
        }

        if (validateField()) {
            pushData();
        }

    }

    return (
        <>
            <form id="tab1" className="flex flex-col gap-3 mt-3">
                <InputText validationLabel={data.email.valid} name="email" value={data.email.value} placeholder="Email" disabled={true} />
                <InputText password={true} validationLabel={data.password.valid} name="password" value={data.password.value} onChange={handleChange} placeholder="Mot de passe" label="*Minimum 8 caractères,1 symbole (!@#$%^&*), 1 chiffre et 1 lettre majuscule." />
                <TextButton text="MODIFIER" onClick={submit} />
            </form>

        </>
    );

});
const Tab2 = (({ data, setData, countries }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: {
                value: value,
                valid: ""
            }
        }));
    }

    const handlePhoneChange = value => {
        setData(prevData => ({
            ...prevData,
            phone: {
                value: value,
                valid: ""
            }
        }));
    }

    const submit = () => {

        const validateField = () => {
            let validation = true;
            let dataTmp = { ...data };
            //Phone validation
            if (!validEmpty(data.phone.value)) {
                dataTmp.phone.valid = "Requis";
                validation = false;
            } else if (!validPhone(data.phone.value)) {
                dataTmp.phone.valid = "Numéro invalide";
                validation = false;
            }
            //Champs requis
            if (!validEmpty(data.street.value)) {
                dataTmp.street.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.streetNb.value)) {
                dataTmp.streetNb.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.postalCode.value)) {
                dataTmp.postalCode.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.language.value)) {
                dataTmp.country.valid = "Requis";
                validation = false;
            }
            setData(dataTmp);
            return validation;
        }

        const formatData = () => {

            const formattedData = {
                phone: data.phone.value === "" ? null : data.phone.value,
                language: data.language.value === "" ? null : data.language.value,
                country: data.country.value === "" ? null : data.country.value,
                postal_code: data.postalCode.value === "" ? null : data.postalCode.value,
                street: data.street.value === "" ? null : data.street.value,
                number: data.streetNb.value === "" ? null : data.streetNb.value,
                box: data.box.value === "" ? null : data.box.value
            }
            return formattedData;
        }

        const pushData = () => {

            const xhttp = new XMLHttpRequest();
            document.getElementById("loading").style.display = "flex";
            xhttp.onload = function () {
                if (xhttp.status >= 200 && xhttp.status < 300) {
                    document.getElementById("loading").style.display = "none";
                    window.alert("Données modifiées");
                } else {
                    document.getElementById("loading").style.display = "none";
                    window.alert(this.responseText);
                }
            }
            xhttp.open("PUT", process.env.REACT_APP_API_URL + "account", process.env.REACT_APP_API_HTTPS);
            xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
            xhttp.send(JSON.stringify(formatData()));
        }

        if (validateField()) {
            pushData();
        }

    }

    return (
        <>
            <form id="tab2" className="flex flex-col gap-3 mt-3">
                <InputText validationLabel={data.name.valid} name="name" value={data.name.value} onChange={handleChange} placeholder="Nom" disabled={true} />
                <InputText validationLabel={data.firstname.valid} name="firstname" value={data.firstname.value} onChange={handleChange} placeholder="Prénom" disabled={true} />
                <InputPhone validationLabel={data.phone.valid} onChange={handlePhoneChange} value={data.phone.value} name="phone" placeholder="Téléphone" />
                <InputText validationLabel={data.street.valid} name="street" value={data.street.value} onChange={handleChange} placeholder="Rue" />
                <InputText validationLabel={data.streetNb.valid} name="streetNb" value={data.streetNb.value} onChange={handleChange} placeholder="N°" />
                <InputText validationLabel={data.box.valid} name="box" value={data.box.value} onChange={handleChange} placeholder="Boîte" />
                <InputText validationLabel={data.postalCode.valid} name="postalCode" value={data.postalCode.value} onChange={handleChange} placeholder="Code postal" />
                <InputSelect validationLabel={data.country.valid} options={countries} name="country" defaultValue={data.country.value} onChange={handleChange} placeholder="Pays" />
                <InputSelect validationLabel={data.language.valid} options={[{ id: "FR", label: "Français" }]} placeholder="Langue" name="language" defaultValue={data.language.value} onChange={handleChange} />
                <TextButton onClick={submit} text="MODIFIER" />
            </form>

        </>
    )
});
const Tab3 = ({ data, setData, patientResultPref, urgentResultPref }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: {
                value: value,
                valid: ""
            }
        }));
    }

    const submit = () => {
        if (validateAllField) {
            pushData();
        }
    }

    const validateAllField = () => {
        let validation = true;
        let dataTmp = { ...data };
        //Champs requis
        if (!validEmpty(data.patient_result_preference.value)) {
            dataTmp.patient_result_preference.valid = "Requis";
            validation = false;
        }
        setData(dataTmp);
        return validation;
    }

    const pushData = () => {

        const xhttp = new XMLHttpRequest();
        document.getElementById("loading").style.display = "flex";
        xhttp.onload = function () {
            if (xhttp.status >= 200 && xhttp.status < 300) {
                document.getElementById("loading").style.display = "none";
                window.alert("Données modifiées");
            } else {
                document.getElementById("loading").style.display = "none";
                window.alert(this.responseText);
            }
        }
        xhttp.open("PUT", process.env.REACT_APP_API_URL + "account", process.env.REACT_APP_API_HTTPS);
        xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhttp.setRequestHeader("Authorization", "Token " + Cookies.get('jwtuser'));
        xhttp.send(JSON.stringify(formatData()));
    }

    const formatData = () => {

        const formattedData = {
            newsletter: data.newsletter.value === "" ? null : data.newsletter.value,
            patient_result_preference: data.patient_result_preference.value === "" ? null : data.patient_result_preference.value,
            urgency_preferences: data.urgent_result_preference.value === "" ? null : data.urgent_result_preference.value,
        }
        return formattedData;
    }

    const handleCheckBoxChange = (e) => {
        const { name, checked } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: {
                value: checked,
                valid: ""
            }
        }));
    }

    const handleURP = (e) => {
        const value = Number.parseInt(e.target.value);
        if (data.urgent_result_preference.value.includes(value)) {
            const index = data.urgent_result_preference.value.indexOf(value);
            setData((prev) => ({
                ...prev,
                urgent_result_preference: {
                    value: prev.urgent_result_preference.value.toSpliced(index, 1),
                    valid: ""
                }
            }))
        } else {
            setData((prev) => ({
                ...prev,
                urgent_result_preference: {
                    value: prev.urgent_result_preference.value.concat(value),
                    valid: ""
                }
            }))
        }
    }

    return (
        <>
            <form id="tab4" className="flex flex-col gap-3 mt-3 text-sm text-dark-green">
                <div>
                    <p>Délai d'accessibilité des résultats par le propriétaire: (uniquement lorsque le dossier est payé)</p>
                    <InputSelect validationLabel={data.patient_result_preference.valid} options={patientResultPref} placeholder="Délai résultats propriétaire" defaultValue={data.patient_result_preference.value} name="patient_result_preference" onChange={handleChange} />
                </div>
                <div>
                    <p>Communication des résultats</p>
                    <InputCheckBox checked={true} disabled={true} label="PLATEFORME" />
                    {urgentResultPref.map((item) => <InputCheckBox key={item.id} checked={data.urgent_result_preference.value.includes(item.id)} name={item.label} value={item.id} onChange={handleURP} label={item.label} />)}
                </div>
                <div>
                    <p>Inscription à la newsletter</p>
                    <InputCheckBox checked={data.newsletter.value} name="newsletter" onChange={handleCheckBoxChange} label="OUI" />
                </div>
            </form>
            <TextButton className="mt-3" onClick={submit} text="MODIFIER" />
        </>
    )
}
